import React, { FC } from 'react';
import { GetLatestReleases_getLatestReleases_items } from '../__queries__';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import { useI18n } from '~Hooks';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import { DateTime } from 'luxon';
import Heading from '~ComponentsImproved/Typography/Heading';
import ReleaseImage from '../ReleaseImage';

const Wrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  text-transform: none;
  position: relative;
  padding: 8px 16px 8px 16px;
  border-radius: 0px;
  border-bottom: 1px solid var(--colorBlueGray1000);
`;

interface Props {
  release: GetLatestReleases_getLatestReleases_items;
}

/** UI Component for release with type FEATURE */
const Feature: FC<Props> = ({ release }) => {
  const { i18n } = useI18n();

  return (
    <Wrapper>
      <Box
        display="flex"
        gap="small"
        flexDirection="row"
        alignItems="flex-start"
        style={{ position: 'relative', zIndex: 1 }}>
        <ReleaseImage imageUrls={release.imageUrls || []} />

        <Box display="flex" flexDirection="column" alignItems="flex-start">
          <Paragraph level={5} color="var(--colorBlueGray300)" top={4} bottom={4}>
            {DateTime.fromISO(release.createdAt, { zone: 'utc' })
              .setZone('local')
              .toFormat('d MMMM yyyy HH:mm')}
          </Paragraph>

          <Heading level={4} color="var(--colorWhite)" bottom={4}>
            {i18n(release.titleLang)}
          </Heading>

          <Paragraph level={5} color="var(--colorBlueGray200)" bottom={16}>
            {(() => {
              const bodyText = i18n(release.bodyLang);

              return bodyText.split('\n\n').map((paragraph, i) => (
                <React.Fragment key={i}>
                  {i > 0 && (
                    <>
                      <br />
                      <br />
                    </>
                  )}
                  {paragraph.split('\n').map((line, j) => (
                    <React.Fragment key={j}>
                      {j > 0 && <br />}
                      {line}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ));
            })()}
          </Paragraph>
        </Box>
      </Box>
    </Wrapper>
  );
};

export default Feature;
